import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";

import { Row, Col, Icon, Tabs, Spin, Typography, Radio, Cascader } from "antd";
import { Legend, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line, } from 'recharts'
// Component
import Button from "../../../../Buttons";
import typo, { MESSAGE } from "../../../../../constants/dictionaries";
import message from "../../../../Messages";
import helper from "../../../../../helper/helper"
import Table from "../../../../Table";
import columns from "./colums";
import Select from "../../../../Common/Select"
// import BieuDo from "../BieuDo"
// Colors
import colors from "../../../../../constants/colors";

// Styled components
import styles from "./Modal.module.scss";
import constants from "../../../../../constants/constant";
import Api_quantrac from "../../../../../api/api.quantrac";
const { Text } = Typography;
const { TabPane } = Tabs;
const ControllerForm = styled.div`
  // border: 1px solid #c8ced3;
  border-radius: 5px;
  background: ${colors.white};
`;
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;
const compare = (a, b) => {
  if (a.id < b.id) {
    return 1;
  }
  if (a.id > b.id) {
    return -1;
  }
  return 0;
}

class DanhGiaModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      data_bieudo: [],
      addColums: [],
      dataThongSo: [],
      widthX: 0,
      loading: false,
      data_doituong: [],
      doituongQT: undefined,
      selectThongSo: undefined,
      changeBieudo: 1,
      data_qcvn_mdsd: [],
      qcvn_mdsd: []
    };
  }

  componentDidMount() {
    this.setState({ loading: true })
    this.GetTPMT_Exist()
  }

  GetQT_DMQCVN_MDSD = (tpmt_ma) => {
    new Api_quantrac()
      .GetQT_DMQCVN_MDSD({
        token: this.props.user.access_token,
        tpmt_ma: tpmt_ma
      })
      .then(res => {
        this.setState({
          data_qcvn_mdsd: res,
        });
      }).catch(err => {
        message.error(err.message)
      });
  };

  GetThongSos_Exist = (tpmt_ma) => {
    const { selectedRow, GetThongSos_Exist } = this.props
    GetThongSos_Exist({
      token: this.props.user.access_token,
      id_thongtinchung: selectedRow.thongTinChung_Id,
      id_tramqt: selectedRow.id,
      tpmt_ma: tpmt_ma
    })
      .then(res => {
        this.setState({
          dataThongSo: res,
        });
      }).catch(err => {
        message.error(err.message)
      });
  };

  GetDanhGia_Excel = (idDMQCVN, idMDSD) => {
    const { selectedRow, GetDanhGia_Excel } = this.props
    const { doituongQT } = this.state
    GetDanhGia_Excel({
      token: this.props.user.access_token,
      thongTinChung_Id: selectedRow.thongTinChung_Id,
      id_tramqt: selectedRow.id,
      tpmt_ma: doituongQT,
      kyBaoCao: 0,
      idDMQCVN: idDMQCVN,
      idMDSD: idMDSD
    })
    .then(res => {
      this.setState({loading: false})
    })
      .catch(err => {
        message.error(err.message)
      });
  };

  GetBCDK_KQQT_By_ThongSo = (idThongSo, idDMQCVN, doiTuongQT, idMDSD) => {
    const { selectedRow, GetBCDK_KQQT_By_ThongSo } = this.props
    GetBCDK_KQQT_By_ThongSo({
      token: this.props.user.access_token,
      thongso_id: idThongSo,
      idDMQCVN: idDMQCVN,
      idMDSD: idMDSD,
      thongtinchung_id: selectedRow.thongTinChung_Id,
      tpmt_ma: doiTuongQT,
      id_TramQT: selectedRow.id
    })
      .then(res => {
        this.setState({
          data_bieudo: res,
        });
      }).catch(err => {
        message.error(err.message)
      });
  };

  GetTPMT_Exist = () => {
    const { selectedRow, GetTPMT_Exist } = this.props
    GetTPMT_Exist({ token: this.props.user.access_token, id_thongtinchung: selectedRow.thongTinChung_Id, id_tramqt: selectedRow.id })
      .then(res => {
        let data_doituong = []
        res.length > 0 && res.map((vl, idx) => {
          let doituong = constants.THANH_PHAN_MOI_TRUONG.filter(x => x.id === vl)
          data_doituong.push(doituong[0])
        })
        this.setState({
          data_doituong: data_doituong.sort(compare),
          doituongQT: data_doituong.length > 0 ? data_doituong[0].id : undefined
        })
        if (data_doituong.length > 0) {
          this.GetQT_DMQCVN_MDSD(data_doituong[0].id)
          this.GetThongSos_Exist(data_doituong[0].id)
          this.GetBCDK_KQQT_QD(selectedRow.thongTinChung_Id, data_doituong[0].id, 0, 0, selectedRow.id)
        }

      })
      .catch(err => {
        message.error(err.message)
      })
  };

  GetBCDK_KQQT_QD = (thongTinChung_Id, DoiTuongQT, idDMQCVN, idMDSD, IdTramQT) => {
    const { GetBCDK_KQQT_QD } = this.props
    GetBCDK_KQQT_QD({
      token: this.props.user.access_token,
      thongTinChung_Id: thongTinChung_Id,
      tpmt_ma: DoiTuongQT,
      idDMQCVN: idDMQCVN,
      idMDSD: idMDSD,
      id_tramqt: IdTramQT
    })
      .then(res => {
        if (res.length > 0) {
          let dataAddColums = []
          let dataColums = Object.keys(res[0])
          dataColums.map((item, index) => {
            let isVisible = false
            for (var i = 0; i < res.length; i++) {
              if (index !== 0 && index !== 1) {
                isVisible = Object.values(res[i])[index].indexOf("-;") < 0
                if (isVisible) { break; }
              } else {
                isVisible = true
              }
            }
            dataAddColums.push(
              { visible: isVisible, title: item }
            )
          })
          this.setState({
            data: res.map((item, index) => ({ ...item, stt: index + 1 })),
            addColums: dataAddColums,
            widthX: dataAddColums.filter(value => value.visible === true),
            loading: false
          })
        } else {
          this.setState({
            loading: false,
            data: []
          })
        }
      }
      ).catch(err => null);
  };
  onChangeTabs = (value) => {
    const { selectedRow } = this.props
    this.setState({
      doituongQT: Number(value),
      qcvn_mdsd: [],
      data_bieudo: [],
      loading: true,
      selectThongSo: undefined
    })
    this.GetQT_DMQCVN_MDSD(Number(value))
    this.GetThongSos_Exist(Number(value))
    this.GetBCDK_KQQT_QD(selectedRow.thongTinChung_Id, Number(value), 0, 0, selectedRow.id)
  }
  QCVN_MDSD = (value, selectedOptions) => {
    const { selectedRow } = this.props
    const { doituongQT, changeBieudo, selectThongSo } = this.state
    this.setState({
      qcvn_mdsd: value,
      loading: true
    })
    this.GetBCDK_KQQT_QD(selectedRow.thongTinChung_Id, doituongQT, selectedOptions[0].id, selectedOptions[1].id, selectedRow.id)
    changeBieudo === 2 && selectThongSo && this.GetBCDK_KQQT_By_ThongSo(selectThongSo, selectedOptions[0].id, doituongQT, selectedOptions[1].id)
  }
  onSelectThongSoQT = (value, name) => {
    const { qcvn_mdsd, doituongQT } = this.state
    this.setState({ selectThongSo: value })
    this.GetBCDK_KQQT_By_ThongSo(value, qcvn_mdsd.length > 0 ? Number(qcvn_mdsd[0]) : 0, doituongQT, qcvn_mdsd.length > 0 ? Number(qcvn_mdsd[1]) : 0)
  }

  downloadFilePdf = () => {
    const input = document.getElementById('chart-to-export-bcdk-quantrac');
    helper.exportPdf(input, 'landscape', "BieuDo.pdf")
  }
  CustomizedAxisTick = (item) => {
    return (
      <g transform={`translate(${item.x},${item.y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">{item.payload.value}</text>
      </g>
    );
  };
  onChangeRadio = (value) => {
    const { qcvn_mdsd, doituongQT } = this.state
    const { selectedRow } = this.props
    if (value === 1) {
      this.setState({
        changeBieudo: value
      })
      qcvn_mdsd.length > 0 && this.GetBCDK_KQQT_QD(selectedRow.thongTinChung_Id, doituongQT, Number(qcvn_mdsd[0]), Number(qcvn_mdsd[1]), selectedRow.id)
    } else if (value === 2) {
      this.setState({
        changeBieudo: value,
        selectThongSo: undefined,
        data_bieudo: []
      })
    }
  }
  downloadFile = () => {
    const { qcvn_mdsd } = this.state
    this.setState({loading: true})
    qcvn_mdsd.length > 0 ? this.GetDanhGia_Excel(Number(qcvn_mdsd[0]), Number(qcvn_mdsd[1])) : this.GetDanhGia_Excel(0, 0)
  }
  render() {
    const {
      data,
      data_bieudo,
      addColums,
      data_doituong,
      widthX,
      loading,
      changeBieudo,
      data_qcvn_mdsd,
      qcvn_mdsd,
      dataThongSo,
      selectThongSo
    } = this.state
    const { handleCloseModal, selectedRow } = this.props
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    return (
      <ControllerForm>
        <Row type='flex' justify='end'>
          <Radio.Group name="radiogroup" defaultValue={1} >
            <Radio style={radioStyle} value={1} onChange={(e) => this.onChangeRadio(e.target.value)}>{typo.cscore_info_mau_QT}</Radio>
            <Radio style={radioStyle} value={2} onChange={(e) => this.onChangeRadio(e.target.value)}>{typo.cscore_chart}</Radio>
          </Radio.Group>
        </Row>
        <div className="mt-20"></div>
        <Spin spinning={loading} size="large" tip={typo.cscore_loading_data}>
          <div>
            <Tabs tabPosition='left' onChange={this.onChangeTabs}>
              {data_doituong.map((vl, idx) => <TabPane tab={vl.ten} key={vl.id}>
                <div>
                  <Row type="flex">
                    {changeBieudo === 2 &&
                      <Col style={{ marginRight: 10 }}>
                        <Select
                          dataSource={dataThongSo}
                          onChange={(value, name) => this.onSelectThongSoQT(value, name)}
                          placeholder={typo.cscore_drawer_qt_tt}
                          defaultValue={selectThongSo}
                          key={selectThongSo}
                          mandatory={false}
                          width="200px"
                          name="tenThongSo"
                          name_value="idThongSo"
                        />
                      </Col>}
                    <Col style={{ width: '50%' }}>
                      <Cascader
                        options={data_qcvn_mdsd}
                        onChange={(value, selectedOptions) => {
                          value.length > 0 && value && this.QCVN_MDSD(value, selectedOptions)
                        }
                        }
                        placeholder={typo.cscore_TCAD_DG}
                        key={qcvn_mdsd}
                        defaultValue={qcvn_mdsd ? qcvn_mdsd : undefined}
                        style={{ width: '100%' }}
                      />
                    </Col>
                  </Row>
                  <div className="mt-20"></div>
                  {changeBieudo === 1 &&
                    <Table
                      columns={columns({
                        addColums: addColums,

                      })}
                      scroll={{ x: widthX.length > 9 ? widthX.length * 120 : 'auto', y: 500 }}
                      dataSource={data}
                      hideTotal="true"
                      hideTotal={false}
                      hideSize={true}
                      pagination={false}

                    />}
                  {changeBieudo === 2 &&
                    <div id="chart-to-export-bcdk-quantrac">
                      <div style={{ width: "100%" }}>
                        <ResponsiveContainer height={400} width="90%">
                          <LineChart data={data_bieudo}
                            margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" height={90} tick={this.CustomizedAxisTick} padding={{ left: 30, right: 30 }} />
                            <YAxis yAxisId="left" />
                            <Tooltip />
                            <Legend />
                            <Line yAxisId="left" type="monotone" dataKey="max" name="Giới hạn trên" stroke="#f5222d" />
                            <Line yAxisId="left" type="monotone" dataKey="min" name="Giới hạn dưới" stroke="#f5222d" />
                            <Line yAxisId="left" type="monotone" dataKey="value" name="Giá trị đo" stroke="#82ca9d" />
                          </LineChart>
                        </ResponsiveContainer>
                        <div style={{ textAlign: "center", fontWeight: "bold" }}>Biểu đồ giá trị đo theo thời gian </div>
                      </div>
                    </div>
                  }
                </div>

              </TabPane>)}
            </Tabs>
          </div>
        </Spin>
        <ControllerButton>
          {changeBieudo === 1 ?
            <Button
              type="excel"
              className={styles.buttonMargin}
              onClick={this.downloadFile}
            >
              <Icon type="file-excel" style={{ marginRight: "8px" }} />
              {typo.cscore_out_excel}
            </Button>
            :
            <Button
              type="pdf"
              className={styles.buttonMargin}
              onClick={this.downloadFilePdf}
            >
              <Icon type="file-excel" style={{ marginRight: "8px" }} />
              {typo.cscore_exportPdf}
            </Button>
          }
          <Button
            type="cancel"
            className={styles.buttonMargin}
            onClick={handleCloseModal}
          >
            <Icon type="arrow-right" />
            {typo.cscore_exit}
          </Button>
        </ControllerButton>
      </ControllerForm>
    )
  }
}


DanhGiaModal.propTypes = {
  handleCloseModal: PropTypes.func.isRequired,
};

export default DanhGiaModal;
